import Router from 'vue-router';
import router from '@/router';
import baseRoutes from './baseRoutes'; //静态路由
import store from '@/store';

// 切换用户时重置router
export function resetRouter() {
  const newRouter = new Router({
    routes: baseRoutes
  });
  router.matcher = newRouter.matcher;
  store.commit('app/menuRouteLoaded', false);
}
